import app from "js/legacy-app";

app.directive('plFilterField', [function () {
    return {
        link: function ($scope, element, $attrs) {

        }
    };
}]);